import { render, staticRenderFns } from "./MyHealthHandover.vue?vue&type=template&id=6742b5a6"
import script from "./MyHealthHandover.vue?vue&type=script&lang=js"
export * from "./MyHealthHandover.vue?vue&type=script&lang=js"
import style0 from "./MyHealthHandover.vue?vue&type=style&index=0&id=6742b5a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports